export default __webpack_public_path__ + "static/media/Garaz1.99022bef.jpeg";